export default __webpack_public_path__ + "03825c29315299dbaedca1daf2f790b9.png";